<template>
    <v-app>
        <sale-customer-balance-summary :dialog="dialog" :data="data"  @update:dialog="dialog = $event"  />
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <base-card
                        title="Customer Balance Summary List"
                        icon="mdi-account-cash-outline"
                        :v-card-text-class="'pa-0'"
                        :loading-allowed="false"
                    >
                                    <v-row class="py-2">

                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi-refresh"
                                                    rounded="xl"
                                                    @click="refreshBalanceSummary"
                                                >
                                                    Refresh
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:loader>
                                            <v-progress-linear
                                                :color="loading"
                                                height="3"
                                                indeterminate
                                            />
                                        </template>

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.customer.name="{ item }">
                                            {{ item.customer?.name || '-' }}
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$insertAccess($route.fullPath)"
                                            >
                                                mdi mdi-invoice-text-plus-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>
                    </base-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import saleCustomerBalanceSummary from '@/components/module/sales/orderManagement/saleCustomerBalanceSummary.vue';
import BaseCard from "@/components/utils/baseCard.vue";
import { toast } from "vue3-toastify";
export default {
        components: {
            saleCustomerBalanceSummary,
            BaseCard
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Customer", key: "customer.name",align: "left" ,sortable: false },
                { title: "Opening Date", key: "opening_date",align: "left" ,sortable: false },
                { title: "Total Opening Balance", key: "opening_balance",align: "left" ,sortable: false },
                // { title: "Total", key: "total",align: "left" ,sortable: false },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
          this.refreshBalanceSummary()
        },
        computed:{
            getSchema() {
                return this.$store.getters.getSaleCustomerBalanceSummaryList;
            },
        },
        methods: {
            openAddCustomerBalance() {
                this.data = {
                    id: '',
                    customer_id: '',
                    opening_date: '',
                    opening_balance: '',
                    sale_invoice_master_id: '',
                };
                this.dialog = true;
            },
            editItem(item){
                this.data = { ...item };
                this.dialog = true;
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Customer', 'Opening Date', 'Opening Balance'];
                const rows = this.getSchema.map(item => [serialNumber++, item.customer?.name || '-', item.opening_date, item.opening_balance]);
                this.$exportTableToPDF(columns,rows,'Customer Balance Summary','customer_balance_summary_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Customer', 'Opening Date', 'Opening Balance']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.customer?.name || '-', item.opening_date, item.opening_balance]);
                });
                this.$exportTableToExcel(data,'customer_balance_summary_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Customer', 'Opening Date', 'Opening Balance']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.customer?.name || '-', item.opening_date, item.opening_balance]);
                });

                this.$exportTableToCSV(data,'customer_balance_summary_' + this.$fileDate());
            },
            refreshBalanceSummary() {
                this.loading = 'blue-darken-3';
                this.$store.dispatch('getSaleCustomerBalanceSummaryList')
                    .then(() => {
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        toast.error(error.response?.data?.message || "Unable to refresh customer balance summary");
                    });
            },
        },
        mounted() {
          console.log(this.$route.fullPath)
        }  
    }
</script>
